// import Template0 from "./Template0"; // note will use in future
import { getRandomAlphaNumericString } from "../../../utility/Utility";
import Template1 from "../../email-template/templates/Template1";
import Template2 from "../../email-template/templates/Template2";
import Template3 from "../../email-template/templates/Template3";
import Template4 from "../../email-template/templates/Template4";
import Template5 from "../../email-template/templates/Template5";
import Template6 from "../../email-template/templates/Template6";

export default class TemplateManager {
  static selectedTemplateId;

  static getTemplate() {
    if (TemplateManager.selectedTemplateId === -1) {
      return {
        metaData: null,
        scripts: null,
        hash: getRandomAlphaNumericString(),
        designElements: [],
      };
    }

    let selectedTemplateId = TemplateManager.selectedTemplateId || 0;
    return TemplateManager.getTemplateData(selectedTemplateId);
  }

  static getTemplateData(templateId) {
    switch (templateId) {
      case 0:
        return Template1.getData();
      case 1:
        return Template2.getData(); 
      case 2:
        return Template3.getData();
      case 3:
        return Template4.getData();
      case 4:
        return Template5.getData();
      case 5:
        return Template6.getData();
      default:
        return Template1.getData();
    }
  }

  static setSelectedTemplateId(id) {
    TemplateManager.selectedTemplateId = id;
  }

  static getSelectedTemplateId() {
    return TemplateManager.selectedTemplateId;
  }
}
